module.exports = __webpack_public_path__ + "img/outdoor.7808f644.svg";